<template>
  <div v-if="libraries.length > 1" :class="['wf-table-row', $style.heading]">
    <div class="wf-group-content">
      <WfCheckbox :status="libraryStatus" @click="handleLibraryCheck" />
      {{ library.name }}
    </div>
  </div>
  <WfVariableCollection
    v-for="collection in library.variableCollections"
    :key="collection.id"
    :collection="collection"
  />
</template>

<style lang="scss" module>
.heading {
  background-color: rgba(0, 0, 0, 0.03);

  :global(.wf-group-content) {
    padding-left: 8px;
  }
}
</style>

<script setup>
import { computed } from 'vue';
import WfCheckbox from '@/components/mainContent/WfCheckbox.vue';
import WfVariableCollection from './WfVariableCollection.vue';
import { useStore } from 'vuex';

const props = defineProps({
  library: {
    type: Object,
    required: true,
  },
});

const store = useStore();

const libraries = computed(() => store.state.variable.libraries);

const libraryStatus = computed(() => store.getters['variable/getLibraryStatus'](props.library));

const handleLibraryCheck = () => {
  store.dispatch('variable/toggleLibrary', props.library);
};
</script>
